import { List, Create, Edit, Users } from "../Components/index.js";

export default [
    {
        path: "/admin/ranks",
        component: () => import("../Components/List.vue"),
        name: "ranks-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/ranks/:id/edit",
        component: Edit,
        name: "ranks-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/ranks/create",
        component: Create,
        name: "ranks-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/ranks/:rank_id/users",
        component: Users,
        name: "ranks-users",
        meta: {
            requiresAuth: true,
        },
    },
];
